import React, { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SortType } from '../../hooks/useUserData';

interface OrderBtnProps {
  // eslint-disable-next-line no-unused-vars
  handleSelectOrder: (sortType: SortType) => void;
}

const OrderBtn: FC<OrderBtnProps> = ({ handleSelectOrder }) => {
  const { t } = useTranslation('my_account');
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(0);
  const optionsList: { title: string; value: SortType }[] = [
    { title: 'Mais novo primeiro', value: 'dateAsc' },
    { title: 'Mais antigo primeiro', value: 'dateDesc' },
    { title: 'Por status', value: 'status' },
    { title: 'Por Assunto', value: 'subject' },
  ];

  const toggleOptions = () => setIsOptionsOpen(!isOptionsOpen);

  return (
    <div className="attendance__order">
      <button
        className="attendance__order-btn"
        type="button"
        aria-haspopup="listbox"
        aria-expanded={isOptionsOpen}
        onClick={toggleOptions}
        data-testid="vbz-list-btn-order"
      >
        Ordenar
        <span
          className="material-icons material-icons-round"
          role="img"
          aria-label={t('order.order')}
          title={t('order.order')}
        >
          &#xE5C7;
        </span>
      </button>

      <ul
        className={`dropdown-menu attendance__order-list ${isOptionsOpen && 'attendance__order-list--open'}`}
        role="listbox"
        aria-activedescendant={optionsList[selectedOption].title}
        tabIndex={-1}
      >
        {optionsList.map((option, index) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <li
            id={option.title}
            className="attendance__order-item"
            role="option"
            aria-selected={selectedOption === index}
            tabIndex={0}
            key={option.title}
            onClick={() => {
              setSelectedOption(index);
              setIsOptionsOpen(false);
              handleSelectOrder(option.value);
            }}
          >
            {option.title}
            {selectedOption === index && (
              <span
                className="material-icons material-icons-round"
                role="img"
                aria-label={t('order.selected')}
                title={t('order.selected')}
              >
                &#xE5CA;
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OrderBtn;
